<template>
    <v-dialog v-model="show" max-width="540">
        <v-card>
            <v-card-title class="tit tit--xs">반품요청</v-card-title>
            <v-card-text>
                <v-text-field v-model="reason" label="반품사유" placeholder=" " hide-details outlined/>
                <v-textarea v-model="demand" label="반품 요구사항 & 상세내용" placeholder=" " hide-details outlined class="mt-4" />
            </v-card-text>
            <v-card-actions>
                <v-spacer/>
                <v-btn text color="grey" @click="close">취소</v-btn>
                <v-btn text color="primary" @click="input">확인</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>
<script>
export default {
    data(){
        return {
            show: false,
            reason: null,
            demand: null
        }
    },
    methods: {
        init(){
            this.reason = null;
        },
        close(){
            this.show = false;
        },
        open(){
            this.show = true;
        },
        input(){
            this.$emit("input", { reason: this.reason, demand: this.demand });
            this.close();
        }
    },
    watch: {
        show(){
            if(!this.show) this.init();
        }
    }
}
</script>